import { INCLUDE_IN_SCREENSHOT } from './UIConstants';
export default function SpacerRow({height,position,rowIndex}){

  
  return (
    <tr class={"" + INCLUDE_IN_SCREENSHOT} style={{
      //background:'blue'
    }}>
      <td
        colspan={10}
  class="rel" style={{
        //background:({bottom:'blue'})[position]||'cyan',
      padding:0,
        height,
        width:'100%',
        //opacity:0.3,
      }}>
      </td>
    </tr>
  )
}
